import PropTypes from 'prop-types'
import { useAppSelector } from '@hooks/store'
import CustomPopoverConfirm from '@UI/CustomPopoverConfirm'
import { Button } from 'antd'
import './styles.css'

const FeatureButton = ({
    code,
    dropdownItem = false,
    noAccessTooltip = 'No tienes permiso para realizar esta acción',
    tooltip = '',
    children,
    popoverProps,
    className,
    style,
    ...buttonProps
}) => {
    const { activeFeatures } = useAppSelector(state => state.roles)

    const isDisabled = !activeFeatures?.find(feature => feature.feature_code === code)?.enabled
    return (
        <CustomPopoverConfirm
            trigger={'hover'}
            content={`${isDisabled && code !== true ? noAccessTooltip : tooltip}`}
            {...popoverProps}
        >
            <Button
                disabled={isDisabled && code !== true}
                className={`${className} ${isDisabled && code !== true ? 'btn-feature-disabled' : ''}`}
                style={dropdownItem ? dropdownItemStyles : style}
                {...buttonProps}
            >
                {children}
            </Button>
        </CustomPopoverConfirm>
    )
}

const dropdownItemStyles = {
    display: 'flex',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    padding: '0px',
    gap: '4px',
    alignItems: 'center',
    textWrap: 'wrap',
    textAlign: 'left',
}

FeatureButton.propTypes = {
    code: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    noAccessTooltip: PropTypes.string,
    tooltip: PropTypes.string,
    dropdownItem: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
    popoverProps: PropTypes.object,
}

export default FeatureButton
